<template lang="pug">
	.schedule-editor.flex-col.space
		Loader(v-if="!campaign || isLoading")
		template(v-else)
			.flex-row.justify.wrap.nav-header-wrapper(v-if="!tab")
				.flex-col.nav-header
					.flex-row.space
						a(@click="() => $router.push({ path: `/campaign/List` })") {{$tCaption('Campaigns')}}
						.spacer /
						a(@click="() => $router.push({ path: `/campaign/Details/${campaign.Oid}` })") {{campaign.Name}}
						.spacer /
						span.nowrap {{$tCaption('Ad rotation')}}
			.flex-row.space(v-if="!tab")
				DxButton(:text="$tCaption('Ad Rotation')", icon="refresh", stylingMode="text", @click="currentView = 'ad'", :activeStateEnabled="false", :focusStateEnabled="false", :type="currentView === 'ad' ? 'default' : 'normal'")
			.flex-col.space(v-else-if="currentView === 'ad' && instruction && !isLoading")
				template(v-for="(instructionLine, idx) in instructionLines")
					ScheduleEditorInstructionLine(ref="instructionLine", :item="instructionLine", :itemIndex="idx", @remove="removeInstructionLine(instructionLine, idx)", :campaignId="campaignId",
						@switch-view="v => currentView = v", :readonly="readonly")
				.flex-row
					Loader(v-if="isAddingNewPeriod")
					DxButton(v-else-if="!readonly", :text="$tCaption('Add new period')", icon="plus", @click="addInstructionLine")
</template>

<script>
	import moment from 'moment';
	import Data from 'app-core/Data';
	import DxTagBox  from 'devextreme-vue/tag-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import DxButton from 'devextreme-vue/button';
	import DxDropDownBox from 'devextreme-vue/drop-down-box';
	import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling } from 'devextreme-vue/data-grid';
	import Dropdown from 'app-core/Dropdown.vue';
	import FileUploader from 'app-core/FileUploader.vue';
	import ScheduleEditorInstructionLine from './ScheduleEditorInstructionLine.vue';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'schedule.ScheduleEditor',
		name: 'schedule-editor',
		components: {
			DxTagBox, DxDateBox, DxCheckBox, DxTextBox, DxSelectBox, DxNumberBox, DxButton, DxDropDownBox,
			DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling, Dropdown,
			FileUploader, ScheduleEditorInstructionLine, Loader
		},
		props: ['tab', 'campaignId', 'readonly'],
		data() {
			return {
				currentView: this.tab || 'ad',
				campaign: null,
				markets: [],
				dayparts: [
					{id: 'mon', text: () => this.$tCaption('Monday')},
					{id: 'tue', text: () => this.$tCaption('Tuesday')},
					{id: 'wed', text: () => this.$tCaption('Wednesday')},
					{id: 'thu', text: () => this.$tCaption('Thursday')},
					{id: 'fri', text: () => this.$tCaption('Friday')},
					{id: 'sat', text: () => this.$tCaption('Saturday')},
					{id: 'sun', text: () => this.$tCaption('Sunday')},
				],
				instructions: [],
				instruction: null,
				instructionLines: [],
				isLoading: 0,
				isAddingNewPeriod: false
			};
		},
		watch: {
			instruction(v) {
				if (v) {
					this.loadInstructionLines(v);
				}
			},
			tab(v) {
				this.currentView = v;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.scheduleEditor = this;
			this.loadData();
		},
		methods: {
			loadData() {
				this.isLoading++;
				return Data.getExternalCampaign(this.campaignId).then(r => this.campaign = r).then(() => {
					this.isLoading++;
					Data.getInstructionsByCampaign(this.campaignId).then(r => {
						if (!r || !r.length) {
							if (__DEBUG__)
								console.debug('Create instruction');
							return Data.postExternalApi('Instruction/CreateUpdateInstruction', { Oid: null, Description: 'New ad rotation', CampaignId: this.campaign.Oid }).then(r => {
								if (__DEBUG__)
									console.debug('Create instruction loaded', { r });
								this.instructions = [r.Data];
								this.instruction = r.Data;
							});
						} else {
							if (__DEBUG__)
								console.debug('Instructions loaded', { r });
							this.instructions = r;
							this.instruction = r[0];
						}
					}).finally(() => this.isLoading--);
					return null;
				}).finally(() => this.isLoading--);
			},
			loadInstructionLines(instruction) {
				if (instruction) {
					this.isLoading++;
					Data.getExternalApi('Instruction/GetInstructionLines', `instructionId=${instruction.Oid}`).then(r => {
						if (__DEBUG__)
							console.debug('Instruction lines loaded', r);
						this.instructionLines = r.Results;
						this.isLoading--;
					});
				}
			},
			addInstructionLine() {
				this.isAddingNewPeriod = true;
				Data.postExternalApi('Instruction/CreateUpdateInstructionLine', {
					Oid: null,
					InstructionId: this.instruction.Oid,
					Monday: true,
					Tuesday: true,
					Wednesday: true,
					Thursday: true,
					Friday: true,
					StartDateTime: moment(this.campaign.StartDate).startOf('day').format('YYYY-MM-DDTHH:mm:SS'),
					EndDateTime: moment(this.campaign.EndDate).startOf('day').format('YYYY-MM-DDTHH:mm:SS')
				}).then(r => {
					if (__DEBUG__)
						console.log('Add new instruction line', { r });
					if (r.Success) {
						this.instructionLines.push(r.Data);
					}
				}).finally(() => this.isAddingNewPeriod = false);
			},
			removeInstructionLine(item, idx) {
				Data.getExternalApi('Instruction/DeleteInstructionLine', `instructionLineId=${item.Oid}`).then(r => {
					if (__DEBUG__)
						console.log('Remove new instruction line', { r });
					if (r.Success) {
						this.instructionLines.splice(idx, 1);
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	.schedule-editor {
		@import "main/themes/generated/variables.base.scss";

		.flex-row {
			> .schedule-cell {
				&:not(:last-child) {
					margin-right: -1px;
				}
			}
		}

		.flex-col {
			> .schedule-cell {
				&:not(:last-child) {
					margin-bottom: -1px;
				}
			}
		}

		.schedule-content {
			padding: 20px;
			background: #fbfbfb;
			margin: 1px;
		}

		.schedule-item:not(:last-child) {
			margin-bottom: 10px !important;
		}

		.markets {			
		}

		.schedule-dates {
			border-left: 4px solid $base-accent;
		}

		/*** ANIMATIONS ***/

		.swing-in-top-fwd {
			-webkit-animation: swing-in-top-fwd 1s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
					animation: swing-in-top-fwd 1s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
		}

		/* ----------------------------------------------
		* Generated by Animista on 2020-7-7 17:44:59
		* Licensed under FreeBSD License.
		* See http://animista.net/license for more info.
		* w: http://animista.net, t: @cssanimista
		* ---------------------------------------------- */

		/**
		* ----------------------------------------
		* animation swing-in-top-fwd
		* ----------------------------------------
		*/
		@-webkit-keyframes swing-in-top-fwd {
			0% {
				-webkit-transform: rotateX(-100deg);
						transform: rotateX(-100deg);
				-webkit-transform-origin: top;
						transform-origin: top;
				//opacity: 0;
			}
			100% {
				-webkit-transform: rotateX(0deg);
						transform: rotateX(0deg);
				-webkit-transform-origin: top;
						transform-origin: top;
				//opacity: 1;
			}
		}

		@keyframes swing-in-top-fwd {
			0% {
				-webkit-transform: rotateX(-100deg);
						transform: rotateX(-100deg);
				-webkit-transform-origin: top;
						transform-origin: top;
				//opacity: 0;
			}
			100% {
				-webkit-transform: rotateX(0deg);
						transform: rotateX(0deg);
				-webkit-transform-origin: top;
						transform-origin: top;
				//opacity: 1;
			}
		}

		.removing {
			opacity: 0.5;
			-webkit-animation: vibrate-1 0.3s linear infinite both;
					animation: vibrate-1 0.3s linear infinite both;
		}

		@-webkit-keyframes vibrate-1 {
			0% {
				-webkit-transform: translate(0);
						transform: translate(0);
			}
			20% {
				-webkit-transform: translate(-2px, 2px);
						transform: translate(-2px, 2px);
			}
			40% {
				-webkit-transform: translate(-2px, -2px);
						transform: translate(-2px, -2px);
			}
			60% {
				-webkit-transform: translate(2px, 2px);
						transform: translate(2px, 2px);
			}
			80% {
				-webkit-transform: translate(2px, -2px);
						transform: translate(2px, -2px);
			}
			100% {
				-webkit-transform: translate(0);
						transform: translate(0);
			}
		}
		@keyframes vibrate-1 {
			0% {
				-webkit-transform: translate(0);
						transform: translate(0);
			}
			20% {
				-webkit-transform: translate(-2px, 2px);
						transform: translate(-2px, 2px);
			}
			40% {
				-webkit-transform: translate(-2px, -2px);
						transform: translate(-2px, -2px);
			}
			60% {
				-webkit-transform: translate(2px, 2px);
						transform: translate(2px, 2px);
			}
			80% {
				-webkit-transform: translate(2px, -2px);
						transform: translate(2px, -2px);
			}
			100% {
				-webkit-transform: translate(0);
						transform: translate(0);
			}
		}
	}
</style>
